import React from 'react'

const ShopContext = React.createContext();
ShopContext.displayName = "ShopContext";

export default ShopContext;